(()=>{
  function applyDiscount(container){
    const input=container?.querySelector('[data-cart-discount-code]');
    const code=input?.value.trim();
    if(!input||!code){
      container?.classList.add('is-error');
      input?.focus();
      return;
    }
    container.classList.remove('is-error');
    const root=window.Shopify?.routes?.root||'/';
    const discountPath=`${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(root+'cart')}`;
    window.location.assign(discountPath);
  }

  document.addEventListener('click',(event)=>{
    const button=event.target.closest('[data-cart-discount-apply]');
    if(!button)return;
    event.preventDefault();
    applyDiscount(button.closest('[data-cart-discount-form]'));
  });

  document.addEventListener('keydown',(event)=>{
    const input=event.target.closest('[data-cart-discount-code]');
    if(!input||event.key!=='Enter')return;
    event.preventDefault();
    applyDiscount(input.closest('[data-cart-discount-form]'));
  });
})();
